export default __webpack_public_path__ + "static/media/ball.cc8f973f.png";